module.exports = __webpack_public_path__ + "mw.svg?d6915440d0eb73323262bafac9e9808b";